import React from 'react';
import FormEntry from 'controls/react/form/formEntry';
import { AntInput } from 'controls/react/ant/antInput';
import { AntInputNumber } from 'controls/react/ant/antInputNumber';
import { AntCheckbox } from 'controls/react/ant/antCheckbox';
import { linkModel, ModelValidator, ValidatableModel } from 'framework/mobx-integration';
import { makeAutoObservable } from 'mobx';
import { Section } from 'controls/react/layout/section';
import { observer } from 'mobx-react';
import { sharedLocalization } from 'vendor-init/tinymce/plugins/localization';
import { ApplicationState } from 'framework/applicationState';
import { AccountSelector } from 'controls/react/accountSelector';
import { AttributesConfig, CustomAttributes } from './attributes';
import { translator } from 'core/localization';
import { DataSourceSelectorPlain } from 'controls/designer/features/widgets/datasources/shared/components/data-source-selector/dataSourceSelector';

const i = translator(sharedLocalization);

export class DatasourceVariableConfig implements ValidatableModel<DatasourceVariableConfig>, AttributesConfig {
	title: string = '';
	accountId: string;
	sourceId: string = '';
	asMap: boolean = false;
	dataPrefix: string = '';
	decimalFormat: string = '';

	attributes = new CustomAttributes();

	validator = new ModelValidator(this);

	constructor() {
		this.accountId = ApplicationState.accountId;
		makeAutoObservable(this);

		this.validator.required('accountId').required('sourceId');
	}

	destroy = () => {
		this.validator.destroy();
	};
}

const DatasourceVariableForm = observer((props: { config: DatasourceVariableConfig }) => {
	return (
		<Section childrenPadding={true} appearance={'none'}>
			<FormEntry label={i('Title')}>
				<AntInput {...linkModel(props.config, 'title')} />
			</FormEntry>
			<FormEntry label={i('Account')} model={props.config} modelField={'accountId'}>
				<AccountSelector />
			</FormEntry>
			<FormEntry label={i('Datasource')} model={props.config} modelField={'sourceId'}>
				<DataSourceSelectorPlain accountId={props.config.accountId} />
			</FormEntry>
			<FormEntry label={i('Data as a map')}>
				<AntCheckbox {...linkModel(props.config, 'asMap')} />
			</FormEntry>
			<FormEntry label={i('Data prefix')}>
				<AntInput {...linkModel(props.config, 'dataPrefix')} />
			</FormEntry>
			<FormEntry label={i('Decimal format')}>
				<AntInputNumber {...linkModel(props.config, 'decimalFormat')} />
			</FormEntry>
		</Section>
	);
});

export const datasourceVariableComponentDescription = {
	id: 'ceeview/datasource-variable',
	type: 'ceeview/datasource-variable',
	title: i('Datasource variable'),
	config: DatasourceVariableConfig,
	form: DatasourceVariableForm,
	preview: require('./datasourceVariable.png'),
	defaultSize: {
		width: '150px',
		height: '50px',
	},
};
